import React, { useEffect, useState } from "react";
import styled, { keyframes } from "styled-components";
import FormField from "../../../common/FormField/FormField";
import { Formik } from "formik";
import { PrimaryCTAButton } from "../../../common/CustomButtons";
import { Images } from "../../../../assets/images";
import useLoader from "../../../../hooks/useLoader";
import { useSnackbar } from "notistack";
import AuthService from "../../../../services/AuthService";
import { getErrorMessage } from "../../../../helpers/functions";
import { EnquiryValidationSchemaSchema } from "../../../../helpers/validationSchema";
import OptimizedBgImage from "./OptimizedBgImage";
import { H2 } from "../../AboutUs/Styles";
import useCartCount from "../../../../hooks/useCartCount";
import theme from "../../../../assets/theme";
import COLORS from "../../../../assets/Colors";

export default function AccreditationUI(props) {
  const { setLoader } = useLoader();
  const { enqueueSnackbar } = useSnackbar();
  const [isMobile, setIsMobile] = useState(false);
  const { scrollContactTick } = useCartCount();

  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const checkMobile = () => {
      setIsMobile(window.innerWidth <= 768);
    };

    checkMobile();
    window.addEventListener("resize", checkMobile);

    return () => window.removeEventListener("resize", checkMobile);
  }, []);

  async function onFormSubmit(values, { resetForm }) {
    try {
      setLoader({ state: true, message: "Loading..." });
      const payload = {
        fullName: values?.fullName,
        email: values?.email,
        mobile: values?.mobile,
        location: values?.location,
        message: values?.message,
      };
      await AuthService.enquireMail(payload);
    } catch (error) {
      const message = getErrorMessage(error);
      enqueueSnackbar(message, {
        variant: "error",
      });
    } finally {
      setLoader({ state: false });
      setIsSubmitted(true);
      resetForm();
    }
  }

  const accreditations = [
    { name: "Legal Cert", color: "#ff6b35", icon: Images.EmpanelmentOne },
    { name: "SEBI Certified", color: "#4a90e2", icon: Images.EmpanelmentTwo },
    { name: "IIAC Certified", color: "#50c878", icon: Images.EmpanelmentThree },
    { name: "Memory Monitor", color: "#9b59b6", icon: Images.EmpanelmentFour },
    { name: "ISO Certified", color: "#e74c3c", icon: Images.EmpanelmentFive },
  ];

  /*

  const bussiness_inputs = [
    {
      name: "Rahul Nanuhal",
      title: "Co-Founder & CEO",
      mailto: "rahul@justact.co.in",
      icon: Images.Rahul,
      link: "https://www.linkedin.com/in/nanuhal/",
    },
    {
      name: "Madhav Pudipeddi",
      title: "Co Founder & COO",
      mailto: "madhav@justact.co.in",
      icon: Images.Madhav,
      link: "https://www.linkedin.com/in/madhav-pudipeddi-95a50020/",
    },
  ];

  */

  const inputs = [
    {
      type: "text",
      name: "fullName",
      label: "Full Name",
    },
    {
      type: "email",
      name: "email",
      label: "Email Id",
    },
    {
      type: "mobile",
      name: "mobile",
      label: "Mobile Number",
    },
    {
      type: "text",
      name: "location",
      label: "Location",
    },
    {
      type: "textarea",
      name: "message",
      label: "Message",
      rowsMax: 2,
    },
  ];

  useEffect(() => {
    const scrollToSection = () => {
      const element = document.getElementById("enquire-now");
      if (props.props.location.hash.includes("enquire-now")) {
        const y = element.getBoundingClientRect().top + window.pageYOffset - 70;
        window.scrollTo({ top: y, behavior: "smooth" });
      }
    };
    setTimeout(scrollToSection, 100); // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [scrollContactTick, props.props.location.hash.includes("enquire-now")]);

  return (
    <Container>
      <AccreditationsSection>
        <H2 style={{ textAlign: "center", marginBottom: "30px", marginTop: 10 }}>
          Accreditations & Empanelment
        </H2>
        <AccreditationsContainer>
          {isMobile ? (
            <MobileAccreditationsGrid>
              {accreditations.map((accreditation, index) => (
                <AccreditationCard key={index}>
                  <OptimizedBgImage
                    src={accreditation.icon}
                    alt={accreditation.name}
                    height="60px"
                    borderRadius="50%"
                    style={{
                      width: "90px",
                      height: "60px",
                    }}
                  />
                </AccreditationCard>
              ))}
            </MobileAccreditationsGrid>
          ) : (
            <AccreditationsSlider>
              <AccreditationSlide>
                {accreditations.map((accreditation, index) => (
                  <AccreditationCard key={`set1-${index}`}>
                    <OptimizedBgImage
                      src={accreditation.icon}
                      alt={accreditation.name}
                      height="80px"
                      borderRadius="50%"
                      style={{
                        width: "120px",
                        height: "80px",
                      }}
                    />
                  </AccreditationCard>
                ))}
              </AccreditationSlide>
              <AccreditationSlide>
                {accreditations.map((accreditation, index) => (
                  <AccreditationCard key={`set2-${index}`}>
                    <OptimizedBgImage
                      src={accreditation.icon}
                      alt={accreditation.name}
                      height="80px"
                      borderRadius="50%"
                      style={{
                        width: "120px",
                        height: "80px",
                      }}
                    />
                  </AccreditationCard>
                ))}
              </AccreditationSlide>
              <AccreditationSlide>
                {accreditations.map((accreditation, index) => (
                  <AccreditationCard key={`set3-${index}`}>
                    <OptimizedBgImage
                      src={accreditation.icon}
                      alt={accreditation.name}
                      height="80px"
                      borderRadius="50%"
                      style={{
                        width: "120px",
                        height: "80px",
                      }}
                    />
                  </AccreditationCard>
                ))}
              </AccreditationSlide>
            </AccreditationsSlider>
          )}
        </AccreditationsContainer>
      </AccreditationsSection>
      <H2
        style={{ textAlign: "center", marginBottom: "30px" }}
        id="enquire-now"
      >
        Contact Us
      </H2>
      <MainContentContact>
        {!isSubmitted ? (
          <Formik
            initialValues={{
              fullName: "",
              email: "",
              mobile: "",
              location: "",
              message: "",
            }}
            validationSchema={EnquiryValidationSchemaSchema}
            enableReinitialize
            onSubmit={onFormSubmit}
            validateOnBlur
            validateOnChange
          >
            {({
              values,
              handleChange,
              errors,
              handleSubmit,
              touched,
              resetForm,
              handleBlur,
              setFieldValue,
            }) => (
              <ContactForm onSubmit={handleSubmit} className="mis-dashboard">
                {inputs.map((input, index) => (
                  <FormField
                    fontSize="14"
                    key={index}
                    {...{
                      touched,
                      errors,
                      input,
                      values,
                      handleChange,
                      handleBlur,
                      setFieldValue,
                    }}
                  />
                ))}
                <PrimaryCTAButton
                  style={{ marginTop: 15 }}
                  onClick={handleSubmit}
                >
                  Submit
                </PrimaryCTAButton>
              </ContactForm>
            )}
          </Formik>
        ) : (
          <ContactForm
            style={{ textAlign: "center", padding: "40px", fontSize: "18px" }}
          >
            Thank you for contacting IAMC. Your details are successfully
            submitted. Our team is reviewing your request and will reach out
            within one business day.
          </ContactForm>
        )}
      </MainContentContact>
    </Container>
  );
}

export const slideIn = keyframes`
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
`;

const infiniteScroll = keyframes`
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-33.333%);
  }
`;

export const Container = styled.div`
  min-height: 100vh;
  background: #ffffff;
  padding: 20px;
  font-family: "Arial", sans-serif;

  @media (max-width: 768px) {
    padding: 10px;
  }
`;

const AccreditationsSection = styled.section`
  margin-bottom: 40px;

  @media (max-width: 768px) {
    margin-bottom: 30px;
  }
`;

const AccreditationsContainer = styled.div`
  position: relative;
  overflow: hidden;
  border-radius: 15px;
  background: white;
  padding: 20px;
  margin-bottom: 30px;

  @media (max-width: 768px) {
    padding: 20px 10px;
    overflow: visible;
  }
`;

const MobileAccreditationsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 15px;
  width: 100%;
  justify-items: center;

  @media (max-width: 480px) {
    grid-template-columns: repeat(2, 1fr);
    gap: 10px;
  }

  @media (max-width: 360px) {
    grid-template-columns: 1fr;
    gap: 12px;
  }
`;

export const AccreditationsSlider = styled.div`
  display: flex;
  animation: ${infiniteScroll} 30s linear infinite;
  width: 300%;

  &:hover {
    animation-play-state: paused;
  }
`;

const AccreditationSlide = styled.div`
  min-width: 33.333%;
  display: flex;
  justify-content: space-around;
  align-items: center;
  gap: 20px;
`;

const AccreditationCard = styled.div`
  background: white;
  border-radius: 12px;
  padding: 20px;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.08);
  border: 2px solid #e1e8ed;
  transition: all 0.3s ease;
  flex-shrink: 0;
  animation: ${slideIn} 0.6s ease-out;
  flex: 1;
  max-width: 250px;
  min-height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 120px;

  &:hover {
    transform: translateY(-5px);
    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.15);
    border-color: #00818a;
  }

  @media (max-width: 768px) {
    padding: 15px;
    min-height: 90px;
    width: 100%;
    max-width: 150px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    min-height: 80px;
    max-width: 140px;
  }

  @media (max-width: 360px) {
    max-width: 200px;
  }
`;

const MainContentContact = styled.div`
  display: grid;
  grid-template-columns: 1fr;
  gap: 40px;
  width: 60%;
  margin: 0 auto;

  @media (max-width: 1200px) {
    width: 70%;
  }

  @media (max-width: 968px) {
    width: 80%;
    gap: 30px;
  }

  @media (max-width: 768px) {
    width: 90%;
  }

  @media (max-width: 480px) {
    width: 95%;
    gap: 20px;
  }
`;

export const ContactForm = styled.form`
  background: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
  font-family: ${theme.fonts.primaryFontSemiBold};
  color: ${COLORS.COLOR_DARK};

  @media (max-width: 768px) {
    padding: 30px;
    border-radius: 12px;
  }

  @media (max-width: 480px) {
    padding: 20px;
    border-radius: 10px;
  }
`;

export const ConsultationSection = styled.div`
  background: ${({ background }) => (background ? background : "#00818a")};
  color: white;
  padding: 40px;
  border-radius: 15px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);

  @media (max-width: 768px) {
    padding: 30px;
  }

  @media (max-width: 480px) {
    padding: 20px;
  }
`;

/*

const ConsultationTitle = styled.h2`
  font-size: 2rem;
  margin-bottom: 20px;
  font-weight: 300;
  font-family: openSans-SemiBold, sans-serif;

  @media (max-width: 768px) {
    font-size: 1.5rem;
    margin-bottom: 15px;
  }

  @media (max-width: 480px) {
    font-size: 1.3rem;
  }
`;

const ConsultationSubtitle = styled.p`
  font-size: 1.1rem;
  margin-bottom: 30px;
  opacity: 0.9;
  font-family: openSans-SemiBold, sans-serif;

  @media (max-width: 768px) {
    font-size: 1rem;
    margin-bottom: 25px;
  }

  @media (max-width: 480px) {
    font-size: 0.9rem;
  }
`;

const ConsultantCard = styled.div`
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(10px);
  border-radius: 12px;
  padding: 20px;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  gap: 15px;
  width: 100%;
  height: 35%;
  transition: transform 0.3s ease;

  &:hover {
    transform: translateX(5px);
    background: rgba(255, 255, 255, 0.15);
  }

  @media (max-width: 768px) {
    flex-direction: column;
    text-align: center;
    padding: 15px;
  }

  @media (max-width: 480px) {
    padding: 12px;
    gap: 10px;
  }
`;

const ConsultantInfo = styled.div`
  flex: 1;
`;

const ConsultantTitleInfo = styled.div`
  display: flex;
  flex-direction: row;
  gap: 18px;
  align-items: center;

  @media (max-width: 768px) {
    flex-direction: column;
    align-items: flex-start;
  }
`;

const ConsultantName = styled.h3`
  margin: 0 0 5px 0;
  font-size: 1.2rem;

  @media (max-width: 480px) {
    font-size: 1.1rem;
  }
`;

const ConsultantTitle = styled.p`
  margin: 0 0 10px 0;
  opacity: 0.8;
  font-size: 0.9rem;
`;

const ContactLinks = styled.div`
  display: flex;
  gap: 10px;
  align-items: center;

  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    gap: 8px;
  }
`;

const ContactLink = styled.a`
  color: white;
  text-decoration: none;
  display: flex;
  align-items: center;
  gap: 5px;
  padding: 8px 12px;
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.1);
  font-size: 0.8rem;
  transition: background 0.3s ease;

  &:hover {
    background: rgba(255, 255, 255, 0.2);
  }

  @media (max-width: 480px) {
    padding: 6px 10px;
    font-size: 0.7rem;
  }
`;

*/
